import React from "react";
import { Row, Col, Select } from "antd";
import CustomerSatisfactionDriversWidget from "./CustomerSatisfactionDriversWidget";
import DriverwiseReviewTrend from "./DriverwiseReviewTrend";
import { IReviewsDataFormatted } from "@ts/common-types";
import WidgetCard from "./WidgetCard";
import { showToast } from "@ts/modals";

interface ICsAndReviewTrendGroupedWidget {
    reviewsDataFormatted: IReviewsDataFormatted;
    type?: string;
    selectedFeature?: string[];
    setSelectedFeature?: React.Dispatch<React.SetStateAction<string[]>>;
}
const CsAndReviewTrendGroupedWidget: React.FC<
    ICsAndReviewTrendGroupedWidget
> = ({ reviewsDataFormatted, selectedFeature, setSelectedFeature, type }) => {
    const handleChange = (value: string[]) => {
        if (value.length > 5) {
            showToast("danger", "You can select maximum 5 features");
            return;
        }
        setSelectedFeature(value);
    };

    return (
        <WidgetCard>
            <Row className="mb-3" justify="space-between" align="middle">
                <Col>
                    <h5>Customer Satisfaction Drivers and Trends</h5>
                </Col>
                {type === "skus" ? (
                    <Col>
                        <label className="me-2">Features:</label>
                        <Select
                            style={{ width: "25ch" }}
                            options={
                                reviewsDataFormatted?.csDriversTrendsFeatures
                            }
                            mode="multiple"
                            allowClear
                            value={
                                selectedFeature || [
                                    reviewsDataFormatted
                                        ?.csDriversTrendsFeatures[0].value,
                                ]
                            }
                            onChange={handleChange}
                            maxLength={5}
                            maxTagCount={1}
                            maxTagTextLength={10}
                        />
                    </Col>
                ) : null}
            </Row>
            <Row justify={"center"} align={"middle"} gutter={12}>
                <Col span={12}>
                    <CustomerSatisfactionDriversWidget
                        type="sub-module"
                        widgetData={
                            reviewsDataFormatted?.customerSatisfactionDriver
                        }
                    />
                </Col>
                <Col span={12}>
                    <DriverwiseReviewTrend
                        type="sub-module"
                        widgetData={reviewsDataFormatted?.driverwiseReviewTrend}
                    />
                </Col>
            </Row>
        </WidgetCard>
    );
};

export default CsAndReviewTrendGroupedWidget;